/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react'
import '../../Style/Table4.css'
import MaterialTable from 'material-table'
// import GetAppIcon from '@material-ui/icons/GetApp'
import AddIcon from '@material-ui/icons/Add'
import { Grid, Divider, Button } from '@material-ui/core'
import Table541 from './Table541'
import { Modal54 } from '../../Modals/ModalSec5/Modal54'
import { getMasterSubprojectBudget } from '../../../../../services/Elegibilidad/get'
import NumberFormat from 'react-number-format'
import { useEligibility } from '../../../../../context/EligibilityContext'

const Table54 = ({ idElegibilityForm, formik, setLoadingTables }) => {
  const [state, dispatch] = useEligibility()
  const [tableData, setTableData] = useState([])
  const [openSec54, setOpenSec54] = useState(false)
  const [sumTotalCost, setSumTotalCost] = useState(0)
  const [sumLoan, setSumLoan] = useState(0)

  const [sumMyPyme, setSumMyPyme] = useState(0)

  const [sumOtherContributions, setSumOtherContributions] = useState(0)

  const porcMyPyme = sumTotalCost !== 0 ? (sumMyPyme / sumTotalCost) * 100 : 0
  const porcOtherContributions =
    sumTotalCost !== 0 ? (sumOtherContributions / sumTotalCost) * 100 : 0
  const porcLoan = sumTotalCost !== 0 ? (sumLoan / sumTotalCost) * 100 : 0

  const getDataTableMaster = async () => {
    try {
      const response = await getMasterSubprojectBudget(idElegibilityForm)

      console.log('probando', response)
      if (response.Success) {
        let sumTotalCost = 0
        let SumTotalLoan = 0
        setTableData(response.Data)
        if (setLoadingTables) {
          setLoadingTables(false)
        }
        response.Data.reduce((accumulator, object) => {
          setSumTotalCost(accumulator + object.TotalCost)
          sumTotalCost = accumulator + object.TotalCost
          return accumulator + object.TotalCost
        }, 0)

        response.Data.reduce((accumulator, object) => {
          setSumLoan(accumulator + object.TotalLoanContribution)
          SumTotalLoan = accumulator + object.TotalLoanContribution
          return accumulator + object.TotalLoanContribution
        }, 0)

        response.Data.reduce((accumulator, object) => {
          setSumMyPyme(accumulator + object.TotalMipymeContribution)
          return accumulator + object.TotalMipymeContribution
        }, 0)

        response.Data.reduce((accumulator, object) => {
          setSumOtherContributions(accumulator + object.TotalOtherContributions)
          return accumulator + object.TotalOtherContributions
        }, 0)

        // if (
        //   editFormElegibility.TotalSubProjectBudget === Number(suma.toFixed(2))
        // ) {
        //   console.log('aprobado')
        //   formik.setFieldValue('TotalSubProjectBudgetValidation', true)
        // } else {
        //   console.log(
        //     'no aprobado',
        //     editFormElegibility.TotalSubProjectBudget,
        //     'otro',
        //     sumTotalCost.toFixed(2),
        //   )
        //   formik.setFieldValue('TotalSubProjectBudgetValidation', false)
        // }

        formik.setValues({
          ...formik.values,
          TotalSubProjectBudgetValidation: Number(sumTotalCost.toFixed(2)),
          RequiredAmountValidation: Number(SumTotalLoan.toFixed(2)),
        })
        // if (IdCurrency !== 3) {
        //   if (SumTotalLoan === RequiredAmountSourceCurrency) {
        //     formik.setFieldValue('RequiredAmountValidation', true)
        //   } else {
        //     formik.setFieldValue('RequiredAmountValidation', false)
        //   }
        // } else {
        //   if (SumTotalLoan === RequiredAmount) {
        //     formik.setFieldValue('RequiredAmountValidation', true)
        //   } else {
        //     formik.setFieldValue('RequiredAmountValidation', false)
        //   }
        // }
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (
      state.step === 5 &&
      idElegibilityForm !== undefined &&
      idElegibilityForm !== null &&
      tableData.length === 0
    ) {
      getDataTableMaster()
    }
  }, [state.step])

  const columns = [
    {
      title: 'Categoría',
      field: 'FieldDescription',
      sorting: false,
      filtering: false,
    },
    {
      title: 'Costo Total',
      field: 'TotalCost',
      align: 'right',
      type: 'numeric',
      render: (expense) => (
        <NumberFormat
          value={expense.TotalCost}
          thousandSeparator={true}
          decimalScale={2}
          displayType={'text'}
          isNumericString={true}
          fixedDecimalScale
        />
      ),

      currencySetting: {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
    },
    {
      title: 'Préstamo',
      field: 'TotalLoanContribution',
      align: 'right',
      render: (expense) => (
        <NumberFormat
          value={expense.TotalLoanContribution}
          thousandSeparator={true}
          decimalScale={2}
          displayType={'text'}
          isNumericString={true}
          fixedDecimalScale
        />
      ),
    },
    {
      title: 'MIPYME',
      field: 'TotalMipymeContribution',
      align: 'right',
      render: (expense) => (
        <NumberFormat
          value={expense.TotalMipymeContribution}
          thousandSeparator={true}
          decimalScale={2}
          displayType={'text'}
          isNumericString={true}
          fixedDecimalScale
        />
      ),
    },
    {
      title: 'Otros Aportes',
      field: 'TotalOtherContributions',
      align: 'right',
      render: (expense) => (
        <NumberFormat
          value={expense.TotalOtherContributions}
          thousandSeparator={true}
          decimalScale={2}
          displayType={'text'}
          isNumericString={true}
          fixedDecimalScale
        />
      ),
    },
  ]

  const data2 = [
    {
      IdElegibilityAnswer: 1084,
      IdDataField: 57,
      FieldDescription: 'Costo total del proyecto',
      TotalQuantity: 13,
      TotalCost: sumTotalCost,
      TotalLoanContribution: sumLoan,
      TotalMipymeContribution: sumMyPyme,
      TotalOtherContributions: sumOtherContributions,
    },
    {
      IdElegibilityAnswer: 1084,
      IdDataField: 57,
      FieldDescription: 'Contribución en %',
      TotalQuantity: 13,
      TotalCost: '100%',
      TotalLoanContribution: `${porcLoan.toFixed(0)}%`,
      TotalMipymeContribution: `${porcMyPyme.toFixed(0)}%`,
      TotalOtherContributions: `${porcOtherContributions.toFixed(0)}%`,
    },
  ]

  const columns2 = [
    {
      title: 'Categoría',
      field: 'FieldDescription',
      sorting: false,
      filtering: false,
      cellStyle: { width: '22.5%' },
      // align: 'right',
    },
    {
      title: 'Costo Total',
      field: 'TotalCost',
      align: 'right',
      cellStyle: { marginLeft: '20%' },
      render: (expense) => (
        <>
          {typeof expense.TotalCost === 'string' ? (
            <b>{expense.TotalCost}</b>
          ) : (
            // <Grid style={{ marginLeft: '-3%' }}>
            <b>
              <NumberFormat
                // style={{ marginLeft: '-10px' }}
                value={expense.TotalCost}
                thousandSeparator={true}
                decimalScale={2}
                displayType={'text'}
                isNumericString={true}
                fixedDecimalScale
              />
            </b>
            // </Grid>
          )}
        </>
      ),
    },
    {
      title: 'Préstamo',
      field: 'TotalLoanContribution',
      align: 'right',
      // render: (expense) => (
      //   <NumberFormat
      //     value={expense.TotalLoanContribution}
      //     thousandSeparator={true}
      //     decimalScale={2}
      //     displayType={'text'}
      //     isNumericString={true}
      //     fixedDecimalScale
      //   />

      render: (expense) => (
        <>
          {typeof expense.TotalLoanContribution === 'string' ? (
            <b>{expense.TotalLoanContribution}</b>
          ) : (
            <b>
              <NumberFormat
                value={expense.TotalLoanContribution}
                thousandSeparator={true}
                decimalScale={2}
                displayType={'text'}
                isNumericString={true}
                fixedDecimalScale
              />
            </b>
          )}
        </>
      ),
    },
    {
      title: 'MIPYME',
      field: 'TotalMipymeContribution',
      align: 'right',
      // render: (expense) => (
      //   <NumberFormat
      //     value={expense.TotalMipymeContribution}
      //     thousandSeparator={true}
      //     decimalScale={2}
      //     displayType={'text'}
      //     isNumericString={true}
      //     fixedDecimalScale
      //   />
      // ),
      render: (expense) => (
        <>
          {typeof expense.TotalMipymeContribution === 'string' ? (
            <b>{expense.TotalMipymeContribution}</b>
          ) : (
            <b>
              <NumberFormat
                value={expense.TotalMipymeContribution}
                thousandSeparator={true}
                decimalScale={2}
                displayType={'text'}
                isNumericString={true}
                fixedDecimalScale
              />
            </b>
          )}
        </>
      ),
    },
    {
      title: 'Otros Aportes',
      field: 'TotalOtherContributions',
      align: 'right',
      // render: (expense) => (
      //   <NumberFormat
      //     value={expense.TotalOtherContributions}
      //     thousandSeparator={true}
      //     decimalScale={2}
      //     displayType={'text'}
      //     isNumericString={true}
      //     fixedDecimalScale
      //   />
      // ),
      render: (expense) => (
        <>
          {typeof expense.TotalOtherContributions === 'string' ? (
            <b>{expense.TotalOtherContributions}</b>
          ) : (
            <b>
              <NumberFormat
                value={expense.TotalOtherContributions}
                thousandSeparator={true}
                decimalScale={2}
                displayType={'text'}
                isNumericString={true}
                fixedDecimalScale
              />
            </b>
          )}
        </>
      ),
    },
  ]

  return (
    <div className="App">
      <Grid container spacing={1}>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          // style={{
          //   marginLeft: '-15px',
          // }}
        >
          <MaterialTable
            columns={columns}
            data={tableData}
            detailPanel={(rowData) => {
              return (
                <div style={{ paddingLeft: '55px' }}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12}>
                      <Table541
                        rowData={rowData}
                        getDataTableMaster={getDataTableMaster}
                      />
                    </Grid>
                  </Grid>
                </div>
              )
            }}
            renderSummaryRow={({ column, data }) =>
              column.field === 'TotalLoanContribution'
                ? {
                    value: data.reduce(
                      (agg, row) => agg + row.TotalLoanContribution,
                      0,
                    ),
                    style: { background: 'red' },
                  }
                : undefined
            }
            actions={[
              {
                icon: () => (
                  <Button
                    variant="contained"
                    color="success"
                    style={{ backgroundColor: '#27C27D', color: '#FFFFFF' }}
                    startIcon={<AddIcon style={{ color: 'white' }} />}
                  >
                    Agregar registro
                  </Button>
                ),
                tooltip: 'Agregar',
                position: 'toolbar',
                onClick: () => {
                  setOpenSec54(true)
                },
              },
            ]}
            onSelectionChange={(selectedRows) => console.log(selectedRows)}
            options={{
              sorting: true,
              search: true,
              searchFieldAlignment: 'right',
              searchAutoFocus: true,
              searchFieldVariant: 'standard',
              filtering: false,
              paging: true,
              pageSizeOptions: [2, 5, 10, 11],
              pageSize: 11,
              paginationType: 'stepped',
              showFirstLastPageButtons: false,
              paginationPosition: 'bottom',

              exportFileName: 'TableData',
              addRowPosition: 'first',
              actionsColumnIndex: -1,
              selection: false,
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              toolbarButtonAlignment: 'left',
              rowStyle: (data, index) =>
                index % 2 === 0 ? { background: '#f5f5f5' } : null,
              headerStyle: { background: '#004BCE', color: '#fff' },
            }}
            localization={{
              body: {
                editRow: {
                  deleteText: '¿Está seguro de eliminar el registro?',
                },
                emptyDataSourceMessage: 'No hay registros a desplegar',
              },
              header: {
                actions: 'Acciones',
              },
            }}
            title=" "
            icons={{ Add: () => <AddIcon /> }}
            components={{
              Pagination: (props) => (
                <>
                  <Divider style={{ background: 'black' }} variant="middle" />
                  <Divider style={{ background: 'black' }} variant="middle" />
                  <MaterialTable
                    style={
                      {
                        // marginLeft: '-24px',
                        // width: '80%',
                      }
                    }
                    // detailPanel={(rowData) => {}}
                    columns={columns2}
                    data={data2}
                    options={{
                      toolbar: false,
                      header: false,
                      paging: false,
                      rowStyle: {
                        fontWeight: 'bold',
                        marginLeft: '-45px',
                      },
                    }}
                  />
                </>
              ),
            }}
          />
        </Grid>
      </Grid>
      <Modal54
        openSec54={openSec54}
        setOpenSec54={setOpenSec54}
        getDataTableMaster={getDataTableMaster}
      />
    </div>
  )
}

export default React.memo(Table54)
